import { http } from "./api-config";

const apiNotificationClient = http(process.env.VUE_APP_MESSAGING_SERVICE)

export default {
    async sendMail(data, type) {
        try {
            let hasAttachment = false
            let fileList = []
            if (data.fileList && data.fileList.length) {
                hasAttachment = true
                fileList = data.fileList
            }

            let sgTemplateId = process.env.VUE_APP_GENERIC_TEMPLATE_ID
            if (type === "SaveMeeting" || type === "UpdateMeeting" || type === "SaveMeetingDetails") {
                sgTemplateId = process.env.VUE_APP_MEETING_TEMPLATE_ID
            } else if (type === "remindAlert") {
                sgTemplateId = process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID
            }
            const emailData = {
                sgTemplateId,
                mailType: data.mailType,
                isPersonalised: data.isPersonalised,
                personalisedData: data.personalisedData,
                dynamicVariables: data.dynamicVariables,
                subject: "Welcome to Avant",
                tenant: sessionStorage.getItem("tenantId"),
                hasAttachment,
                isFileUpload: false,
                fileList,
                toList: data.toList,
                ccList: [],
                bccList: [],
            };
            const res = await apiNotificationClient.post('sendmail', emailData)
            return res.data
        }
        catch (error) {
            console.log(error.response)
            return error.response.data
        }
    },

    async sendTempMail(emailData) {
        const res = await apiNotificationClient.post('sendmail', emailData)
        return res.data

    },

    async sendEmailWithAttachment(data, type) {
        const sgTemplateId = getTemplateIdByType(type);

        const hasAttachment = Boolean(data.attachments && data.attachments.length);
        const formData = prepareFormData(data, sgTemplateId, hasAttachment);

        if (hasAttachment) {
            appendAttachmentsToFormData(formData, data.attachments);
        }

        const res = await apiNotificationClient.post('sendemailwithattachment', formData);
        return res.data;
    },    
}

function getTemplateIdByType(type) {
    switch (type) {
        case "SaveMeeting":
        case "UpdateMeeting":
        case "SaveMeetingDetails":
            return process.env.VUE_APP_MEETING_TEMPLATE_ID;
        case "remindAlert":
            return process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID;
        default:
            return process.env.VUE_APP_GENERIC_TEMPLATE_ID;
    }
}

function prepareFormData(data, sgTemplateId, hasAttachment) {
    const formData = new FormData();
    formData.append("sgTemplateId", sgTemplateId);
    formData.append("mailType", data.mailType);
    formData.append("isPersonalised", data.isPersonalised);
    formData.append("personalisedData", JSON.stringify(data.personalisedData));
    formData.append("dynamicVariables", JSON.stringify(data.dynamicVariables));
    formData.append("subject", "Welcome to Avant");
    formData.append("tenant", sessionStorage.getItem("tenantId"));
    formData.append("hasAttachment", hasAttachment);
    formData.append("toList", JSON.stringify(data.toList));
    formData.append("ccList", JSON.stringify([]));
    formData.append("bccList", JSON.stringify([]));
    return formData;
}

function appendAttachmentsToFormData(formData, attachments) {
    attachments.forEach(attachment => {
        formData.append('fileAttachments', attachment);
    });
}
